export const setInStore = (type, payload = null) => ({ type, payload });
